import { useEffect, useRef, useState } from 'react';

import _ from 'lodash';

import Input from 'components/Input';
import { TEXT_CREATE_SURVEY } from 'constants/string/texts';

const ParagraphOption = (props) => {
  const { data, isPreview } = props;
  const ref = useRef(null);
  const [line, setLine] = useState(0);

  useEffect(() => {
    if (ref.current) {
      setLine(Math.floor(ref.current.clientHeight / 42));
    }
  }, [ref]);

  return isPreview ? (
    <Input type="textarea" placeholder={TEXT_CREATE_SURVEY.PLACEHOLDER_PARAGRAPH} className="w-full" classNameInput="w-full !h-30 !rounded-lg" />
  ) : (
    <>
      {data.answer ? (
        <>
          <div className="relative" ref={ref}>
            <div
              className="text-black-102 leading-[42px] break-words text-justify"
              style={line <= 2 ? { minHeight: '86px' } : {}}
              dangerouslySetInnerHTML={{ __html: data.answer.replace(/\n/g, '<br />') }}
            ></div>
            {_.range(line).map((item) => (
              <div key={item} className="w-full h-10 border-b border-dashed !border-gray-102/65 absolute left-0" style={{ top: `${item * 42}px` }} />
            ))}
          </div>
        </>
      ) : (
        <>
          <Input
            value={''}
            readOnly
            placeholder={TEXT_CREATE_SURVEY.PLACEHOLDER_PARAGRAPH}
            className="w-full"
            classNameInput="w-full border-0 bg-transparent border-b border-dashed !border-gray-102/65 text-gray-102/65 !p-0 !text-black-102"
          />
          <div className="w-full h-10 border-b border-dashed !border-gray-102/65" />
        </>
      )}
    </>
  );
};

export default ParagraphOption;
